import { onlyUnique } from '~/helpers/array'
import type { CacheTagsDebug } from '../types/cacheTagsDebug'

export default defineNuxtPlugin({
  name: 'bs:cache-debug',
  setup(app) {
    if (import.meta.server && import.meta.dev) {
      const cacheTagsDebug = useState<CacheTagsDebug>('cacheTagsDebug', () => {
        return {
          isSet: false,
          tags: [],
          control: '',
        }
      })

      // @ts-expect-error The type is correct.
      const event = useRequestEvent(app)

      app.hooks.hook('app:rendered', () => {
        useCDNHeaders((v) => {
          cacheTagsDebug.value.isSet = true
          cacheTagsDebug.value.control = v._control.format()
          cacheTagsDebug.value.tags = v._tags.filter(onlyUnique).sort()
        }, event)
      })
    }
  },
})
